export const selectBannerList = (state) => state.banner.banners;
export const selectSelectedBanner = (state) => state.banner.selectedBanner;
export const selectBannerLoading = (state) => state.banner.loading;
export const selectBannerError = (state) => state.banner.error;

export const selectBannerCreateLoading = (state) => state.banner.createLoading;
export const selectBannerCreateSuccess = (state) => state.banner.createSuccess;
export const selectBannerCreateError = (state) => state.banner.createError;

export const selectBannerUpdateLoading = (state) => state.banner.updateLoading;
export const selectBannerUpdateSuccess = (state) => state.banner.updateSuccess;
export const selectBannerUpdateError = (state) => state.banner.updateError;

export const selectBannerDeleteLoading = (state) => state.banner.deleteLoading;
export const selectBannerDeleteSuccess = (state) => state.banner.deleteSuccess;
export const selectBannerDeleteError = (state) => state.banner.deleteError;

